module.exports = "https://static.wanderu.com/ui-react/_next/static/media/wanderu_exclusive_small_peek-horizontal_prod.07dc3c64.png";